export const handleNumericValue = (value: string | number) => {
  if (value === null || value === undefined || isNaN(Number(value)))
    return value;
  return Number(value).toLocaleString();
}
